import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './styles/global.css';
import { register } from './serviceWorkerRegistration'; 

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
      <App />
);

// Register the service worker for production environments
register();
// if (process.env.NODE_ENV === 'production') {
// }
